<ion-list-header class="card">
	<ion-item class="full">
		<ion-grid class="full">

			<ion-row class="ion-justify-content-center">
				<ion-col>
					<img class="logo" [src]="ProjectLogo" />
				</ion-col>
				<ion-col>
					<ion-buttons class="ion-justify-content-end">
						<ion-button (click)="OnGoNotifications()">
							<ion-icon name="notifications-outline" slot="icon-only"></ion-icon>
						</ion-button>
					</ion-buttons>
				</ion-col>
			</ion-row>

		</ion-grid>

	</ion-item>
</ion-list-header>